import { useEffect, useState } from 'react';
import {
	GetApprovers,
	UpdateApprovers,
	CheckApprovalWorkFlowType,
	CreateApprovalFlow,
} from '../../../../_api';
import { APPROVAL_WORKFLOW_TYPES } from '../../_constants';
import styles from '../../../../ApplicationMaintenance.module.scss';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import ApprovalsRequest from '../../../../../../Classes/ResponseModels/ApplicationManagement/ApprovalRequest';
import Spinner from '../../../../../../components/UI/Spinner/Spinner';
//this component rendered if it has been determined that the selected application is configured for single level approvals
const SingleLevelApprovals = ({
	app,
	currentUser,
	readOnly,
	requirementNumber,
}) => {
	const [approvers, setApprovers] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [workflowAlreadyExists, setWorkFlowAlreadyExists] = useState(false);
	//on load, check if approval workflow already exists. retrieve the value for the approvers field
	useEffect(() => {
		CheckApprovalWorkFlowType(
			app.appMaster.id,
			APPROVAL_WORKFLOW_TYPES.SingleLevel
		)
			.then(response => {
				setWorkFlowAlreadyExists(response);
				GetApprovers(
					app.appMaster.id,
					APPROVAL_WORKFLOW_TYPES.SingleLevel
				).then(response => {
					setApprovers(response.reviewers);
				});
			})
			.then(x => setIsLoading(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleChange = e => {
		setApprovers(e.target.value);
	};

	const handleSave = () => {
		let request = new ApprovalsRequest(
			app,
			currentUser,
			APPROVAL_WORKFLOW_TYPES.SingleLevel,
			approvers,
			requirementNumber
		);
		request.RequirementNumber = requirementNumber;
		setIsLoading(true);
		//if workflow doesnt already exist, require window.confirm selection, create approval flow AND THEN update approvers, if it does already exist, do not display window.confirm and only update approvers.
		if (
			!workflowAlreadyExists &&
			window.confirm(
				'This will create the Required entries in TS_Event Matrix table for single level approval work flow. Would you like to continue?'
			)
		) {
			CreateApprovalFlow(request).then(success => {
				if (success) {
					UpdateApprovers(request)
						.then(resp => {
							setApprovers(resp.reviewers);
						})
						.then(x => setIsLoading(false));
				} else {
					console.error('error occurred updating approvers');
				}
			});
		} else {
			UpdateApprovers(request)
				.then(resp => setApprovers(resp.reviewers))
				.then(x => setIsLoading(false));
		}
	};

	//update reviewers using endpoint api/ApplicationManagement/UpdateApprovers (api side implemented)
	//report success
	return (
		<div>
			<h2>Single Level Approval</h2>
			{isLoading ? (
				<Spinner />
			) : (
				<>
					<label>
						Manual Input(
						{approvers?.length || 0}/128)
					</label>{' '}
					<p className={styles.sub_label}>
						Format Multiple Approvers as a semicolon (;) delimited
						list (i.e RecipientOne@UPMC.edu;RecipientTwo@UPMC.edu)
					</p>
					<input
						name='approvers_Input'
						id='approvers_Input'
						type='text'
						maxLength={128}
						value={approvers}
						className={styles.width_full}
						onChange={e => handleChange(e)}
					/>
					<div className={styles.controlsContainer}>
						<Button
							onClick={e => {
								handleSave();
							}}
							outlined
							startIcon={<MaterialIcon icon='save' />}
							className={styles.editButton}
							id='updateApprovals_Save2'
							disabled={readOnly}
						>
							Save
						</Button>
					</div>
				</>
			)}
		</div>
	);
};

export default SingleLevelApprovals;
